module.exports = __webpack_public_path__ + "img/Mobile_App.fbf912b9.png";